/* eslint-disable */

import Vue from 'vue'
import WatermarkingDemo from '../demo/WatermarkingDemo.vue';
import WatermarkingDemoVideo from '../demo/WatermarkingDemoVideo.vue';
import {tns} from "tiny-slider/src/tiny-slider"
import $ from 'jquery';

export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {
        const initImage = () => {
            return new Vue({
                el: '#app',
                render: h => h(WatermarkingDemo)
            })
        }

        const initVideo = () => {
            return new Vue({
                el: '#app-video',
                render: h => h(WatermarkingDemoVideo)
            })
        }
        // JavaScript to be fired on the home page, after the init JS

        const companies = document.querySelector('.companies')
        if(companies){
            tns({
                container: '.companies',
                items: 3,
                slideBy: 'page',
                autoplay: true,
                gutter: 32,
                mouseDrag: true,
                nextButton: '.next',
                prevButton: '.prev',
                responsive: {
                    640: {
                        items: 2
                    },
                    700: {
                        items: 4
                    },
                    900: {
                        items: 5
                    }
                }
            });
        }

        $('.toggle li a').on('click', function (e) {
            e.preventDefault()
            // Toggle buttons
            $('.toggle li a').removeClass('active')
            $('.toggle li img').each(function () {
                $(this).attr('src', $(this).data('img'))
            });
            $(this).addClass('active')

            const img = $(this).find('img')
            img.attr('src', img.data('img-active'))

            /** Load Vue apps **/
            //Create a new DOM to avoid memory leaks
            $(".apps").html(`
                <div id="app" class="hidden"></div>
                <div id="app-video" class="hidden"></div>
            `)
            //Load App
            const app = $(this).data('app');
            if (app === 'image') {
                $('#app').removeClass('hidden')
                initImage()
            } else {
                $('#app-video').removeClass('hidden')
                initVideo()
            }
        })

        initImage()

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/digital-watermarking.js